import {
	DetailsChildrenTab,
	DetailsSectionFiles,
	KanbanBoard,
	type DetailsPageProps
} from 'app/main/components/page-layouts';

import ChronologyListItem from 'app/main/modules/chronology/ChronologyListItem';
import ActivitiesListItem from 'app/main/modules/activities/ActivitiesListItem';
import WorkReportsListItem from 'app/main/modules/workreports/WorkReportsListItem';
import TicketsListItem from 'app/main/modules/tickets/TicketsListItem';

import getInvoicesModuleTableColumns from 'app/main/submodules/invoices/InvoicesModuleTableColumns';

import WbsTab from 'app/main/submodules/wbs/WbsTab';
import ProjectsDetailsTab from './tabs/ProjectsDetailsTab';
// import ProjectsGanttTab from './tabs/ProjectsGanttTab';

const tabs: DetailsPageProps['tabs'] = [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <ProjectsDetailsTab {...props} />
	},
	{
		id: 'docs',
		title: 'MODULE_DOCS_NAME',
		disabled: ({ model, sysSettings, isEdit }) => isEdit || !sysSettings[`docs_${model.core_type}_path`],
		hidden: ({ authorizer, sysSettings }) =>
			sysSettings.docs_enabled !== 'true' ||
			sysSettings.docs_projects_enabled !== 'true' ||
			authorizer.cannot('view', 'docs'),
		content: ({ model, sysSettings }) => (
			<DetailsSectionFiles
				folderPath={`${sysSettings[`docs_${model.core_type}_path`]}\\${model.comp_foldername}\\Progetti\\${model.proj_foldername}`}
			/>
		)
	},
	{
		id: 'wbs',
		title: 'TAB_WBS',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('wbs_nodes') || authorizer.cannot('view', 'wbs_nodes'),
		content: ({ model, updateRefresh }) => (
			<WbsTab
				root={{
					table: 'projects',
					tableId: model.proj_uid,
					title: model.proj_title,
					dateFrom: model.proj_d_from,
					dateTo: model.proj_d_to,
					hasWbs: model.proj_wbs,
					isEditable: model.proj_wbs_editable
				}}
				updateRefresh={updateRefresh}
			/>
		)
	},
	{
		id: 'activities',
		title: 'MODULE_ACTIVITIES_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('activities') || authorizer.cannot('view', 'activities'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="activities"
				content={{ type: 'list', itemLayout: ActivitiesListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'acti_proj_uid', filt_clause: 'equals', filt_value: model.proj_uid }]}
			/>
		)
	},
	// {
	// 	id: 'gantt',
	// 	title: 'DETAILS_TAB_GANTT',
	// 	disabled: ({ isEdit }) => isEdit,
	// 	content: props => <ProjectsGanttTab {...props} />
	// },
	{
		id: 'activities-kanban',
		title: 'DETAILS_PROJECTS_TAB_ACTIVITIES_KANBAN',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('activities') || authorizer.cannot('view', 'activities'),
		content: ({ model }) => (
			<KanbanBoard
				module="activities"
				bucket="activities_statuses"
				defaultFilters={[{ filt_field: 'acti_proj_uid', filt_clause: 'equals', filt_value: model.proj_uid }]}
				baseModel={{
					acti_maac_uid: model.proj_maac_uid,
					acti_dems_uid: model.proj_dems_uid,
					acti_oppo_uid: model.proj_oppo_uid,
					acti_cntr_uid: model.proj_cntr_uid,
					acti_ords_uid: model.proj_ords_uid,
					acti_proj_uid: model.proj_uid,
					acti_parent_acti_uid: model.proj_acti_uid,
					acti_wore_uid: model.proj_wore_uid,
					acti_chro_uid: model.proj_chro_uid,
					acti_tick_uid: model.proj_tick_uid,
					acti_comp_uid: model.proj_comp_uid,
					acti_peop_uid: model.proj_peop_uid
				}}
			/>
		)
	},
	{
		id: 'workreports',
		title: 'MODULE_WORKREPORTS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('workreports') || authorizer.cannot('view', 'workreports'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="workreports"
				content={{ type: 'list', itemLayout: WorkReportsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'wore_proj_uid', filt_clause: 'equals', filt_value: model.proj_uid }]}
			/>
		)
	},
	{
		id: 'invoices',
		title: 'MODULE_INVOICES_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer, sysSettings }) =>
			isModuleDisabled('invoices') ||
			authorizer.cannot('view', 'invoices') ||
			sysSettings.projects_show_financial_stats !== 'true',
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="invoices_rows"
				content={{ type: 'table', getColumns: getInvoicesModuleTableColumns }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[
					{ filt_field: 'invc_deleted', filt_clause: 'not_equal', filt_value: 1 },
					{ filt_field: 'inrw_proj_uid', filt_clause: 'equals', filt_value: model.proj_uid }
				]}
			/>
		)
	},
	{
		id: 'chronology',
		title: 'MODULE_CHRONOLOGY_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('chronology') || authorizer.cannot('view', 'chronology'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="chronology"
				content={{ type: 'list', itemLayout: ChronologyListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'chro_proj_uid', filt_clause: 'equals', filt_value: model.proj_uid }]}
			/>
		)
	},
	{
		id: 'tickets',
		title: 'MODULE_TICKETS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('tickets') || authorizer.cannot('view', 'tickets'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="tickets"
				content={{ type: 'list', itemLayout: TicketsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'tick_proj_uid', filt_clause: 'equals', filt_value: model.proj_uid }]}
			/>
		)
	}
];

export default tabs;
